var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      class: ["cursor-pointer", _vm.isPlaying ? "opacity-3" : ""],
      attrs: {
        "aria-label": "Lire le texte à voix haute",
        title: "Lire le texte",
        disabled: _vm.isPlaying,
      },
      on: { click: _vm.play },
    },
    [
      _vm.isPlaying
        ? [_c("AudioPlayerIcon", { staticClass: "text-success" })]
        : [_vm._v("\n        🔊\n    ")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }